export default __webpack_public_path__ + "static/media/bhs-sjog.d7260972.png";